import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AIPromptType } from '@nu-art/prompting-shared';
import { Button, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Header_AIPrompt.scss';
import { ICONS } from '../icons/icons.js';
import { Tooltip_UserPromptLegend } from './Component_UserPromptLegend/Tooltip_UserPromptLegend.js';
export const Header_AIPrompt = (p) => {
    return _jsxs(LL_H_C, { className: 'h__ai-prompt', children: [_jsxs(LL_V_L, { className: 'h__title', children: [_jsx("h1", { children: p.editable.get('label') }), _jsx("h2", { children: p.editable.get('type') ?? 'Type N/A' })] }), p.editable.get('type') === AIPromptType.user && _jsx(ICONS.information.component, { ...Tooltip_UserPromptLegend }), !p.editable.get('_id') && _jsx(Button, { variant: 'primary', onClick: async () => {
                    try {
                        await p.editable.save();
                    }
                    catch (err) {
                        console.error(err);
                    }
                }, children: "Save" })] });
};
//# sourceMappingURL=Header_AIPrompt.js.map